(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    (function() {
    /* Delegated from document so switchers re-rendered by the theme editor
       (inside the header) keep working without re-binding. */
    function closeAllLocaleDropdowns(except) {
      document.querySelectorAll('.wm-locale-wrap.open').forEach(function(w) {
        if (w === except) return;
        w.classList.remove('open');
        var t = w.querySelector('.wm-locale-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    function openLocaleDropdown(wrap, focusLast) {
      closeAllLocaleDropdowns(wrap);
      wrap.classList.add('open');
      var trigger = wrap.querySelector('.wm-locale-trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var options = wrap.querySelectorAll('.wm-locale-option');
      var target = focusLast ? options[options.length - 1] : options[0];
      if (target) target.focus();
    }

    // Enter / Space on the trigger arrive here as a native click
    document.addEventListener('click', function(e) {
      var el = e.target && e.target.closest ? e.target : null;
      if (!el) return;
      var trigger = el.closest('.wm-locale-trigger');
      var wrap = trigger && trigger.closest('.wm-locale-wrap');
      if (wrap) {
        if (wrap.classList.contains('open')) closeAllLocaleDropdowns();
        else openLocaleDropdown(wrap, false);
        return;
      }
      if (!el.closest('.wm-locale-wrap')) closeAllLocaleDropdowns();
    });

    // Capture phase: runs before the header's Escape handler, which skips
    // events marked consumed here (so Escape closes this menu, not the drawer)
    document.addEventListener('keydown', function(e) {
      var el = e.target && e.target.closest ? e.target : null;
      var wrap = el && el.closest('.wm-locale-wrap');
      if (!wrap) return;
      var trigger = wrap.querySelector('.wm-locale-trigger');
      var isOpen = wrap.classList.contains('open');

      if (e.key === 'Escape' || e.key === 'Esc') {
        if (!isOpen) return;
        e.preventDefault();
        closeAllLocaleDropdowns();
        if (trigger) trigger.focus();
        return;
      }

      if (el === trigger) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          openLocaleDropdown(wrap, e.key === 'ArrowUp');
        }
        return;
      }

      if (!isOpen) return;
      var options = Array.prototype.slice.call(wrap.querySelectorAll('.wm-locale-option'));
      var idx = options.indexOf(el);
      if (idx === -1) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (idx < options.length - 1) options[idx + 1].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (idx > 0) options[idx - 1].focus();
        else { closeAllLocaleDropdowns(); if (trigger) trigger.focus(); }
      } else if (e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        options[e.key === 'Home' ? 0 : options.length - 1].focus();
      } else if (e.key === 'Tab') {
        closeAllLocaleDropdowns();
      }
    }, true);

    // A page restored from the back/forward cache keeps the menu as it was left
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) closeAllLocaleDropdowns();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
